export const RICH_TEXT_FORMATS = [
  'header',
  'bold',
  'italic',
  'underline',
  'strike',
  'link',
  'list',
  'image',
] as const

export const SUMMARY_TABLE_BLOT = 'summary-table'
